// -----------------------------------------------------------------------------
// Scripts for slider
// -----------------------------------------------------------------------------

$(function () {
	const sliders = $('.news-slider__items');

	$.each(sliders, function (index, value) {
		const sliderElement = $(this).find('.slider.posts-list');

		const slider = sliderElement.slick({
			autoplay: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			dots: false,
			adaptiveHeight: true,
			// slide: '.post-item',
			responsive: [
				{
					breakpoint: 1600,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						adaptiveHeight: true,
					}
				},
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						adaptiveHeight: true,
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						adaptiveHeight: true,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false,
						dots: true,
						adaptiveHeight: true,
					}
				},
			]
		});
	});
});